export const VIDEO_NOW_PLAYING_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.VideoNowPlayingTemplateInterface.VideoNowPlayingTemplate';
